import { SiteBrand } from "@/data/brand"
import { LayoutMain } from "@/modules/layout/main"

export const PageHome = () => {
	return <LayoutMain Brand={SiteBrand}>Hello there.</LayoutMain>
}
